import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Callout, RowsSkeletonLoader } from '@node-space/ui-components'
import { MIN_PAGINATION_SIZE } from 'constants/queries'
import { useWalletContext } from 'hooks/context'
import { useDepositAccountsQuery } from 'hooks/queries'
import { useIsActiveWallet } from 'hooks/useActiveWallets'
import MultipleDepositDetails from 'pages/Wallets/components/Deposit/components/MultipleDepositDetails'
import SingleDepositDetails from 'pages/Wallets/components/Deposit/components/SingleDepositDetails'
import type { DepositBankAccount } from 'types/BankAccountsDetails'

export const FiatExtendedDetails = () => {
  const wallet = useWalletContext()
  const {
    isError,
    isFetching: isFetchingDepositDetails,
    data: accountDetails,
  } = useDepositAccountsQuery(wallet?.id?.toString(), true)

  const { t } = useTranslation()
  const isSelectedWalletActive = useIsActiveWallet(wallet)

  return isFetchingDepositDetails ? (
    <RowsSkeletonLoader rows={MIN_PAGINATION_SIZE} />
  ) : (
    <>
      {isError ? (
        <Callout variant="error">{t('oopsSomethingWentWrongFetchDespoitDetails')}</Callout>
      ) : (
        isSelectedWalletActive &&
        (accountDetails?.length > 1 ? (
          <Box className="max-w-mediumLarge">
            <MultipleDepositDetails bankAccounts={accountDetails} wallet={wallet} />
          </Box>
        ) : (
          <Box className="max-w-mediumLarge">
            <SingleDepositDetails
              account={accountDetails?.[0] as DepositBankAccount}
              wallet={wallet}
            />
          </Box>
        ))
      )}
    </>
  )
}
